import { AI_SUMMARY_FOR_PROFILE } from "graphql/queries";
import useQueryData from "hooks/useQueryData";

/**
 * useProfileAiSummary
 *
 * @param {string} profileId - The ID of the profile to fetch the AI summary for.
 */
export default function useProfileAiSummary(profileId) {
  const { data, loading, error } = useQueryData({
    queryName: AI_SUMMARY_FOR_PROFILE,
    keyName: "aiSummaryForProfile",
    variables: {
      profileId,
    },
    skip: !profileId,
  });

  return {
    data: data?.aiSummaryForProfile?.summary,
    summaryHash: data?.aiSummaryForProfile?.summaryHash,
    loading,
    error,
  };
}
